<template>
    <div class="bg-grey-100 w-full py-4">
        <AppContainer class="max-w-screen-md">
            <h3 v-if="title" class="text-dark font-bold text-xl text-center">{{ title }}</h3>

            <div class="mt-4 text-dark">
                <slot></slot>
            </div>
        </AppContainer>
    </div>
</template>

<script>
import AppContainer from "@/Layouts/AppContainer";

export default {
    components: {AppContainer},
    props: {
        title: String
    }
};
</script>

<style scoped>

</style>
